import useMediaQuery from "@hooks/useMediaQuery";
import { Button, Typography } from "@mui/material";
import { ConnectButton } from "@rainbow-me/rainbowkit";

export const CustomConnectButton = ({ UnstoppableDomain }) => {
	const { isMobile } = useMediaQuery();
	return (
		<ConnectButton.Custom>
			{({
				account,
				authenticationStatus,
				chain,
				mounted,
				openAccountModal,
				openChainModal,
				openConnectModal,
			}) => {
				// Note: If your app doesn't use authentication, you
				// can remove all 'authenticationStatus' checks
				const ready = mounted && authenticationStatus !== "loading";
				const connected =
					ready &&
					account &&
					chain &&
					(!authenticationStatus || authenticationStatus === "authenticated");
				return (
					<div
						{...(!ready && {
							"aria-hidden": true,
							style: {
								opacity: 0,
								pointerEvents: "none",
								userSelect: "none",
							},
						})}
					>
						{(() => {
							if (!connected) {
								return (
									<Button onClick={openConnectModal} type="button">
										Connect Wallet
									</Button>
								);
							}
							if (chain.unsupported) {
								return (
									<Button onClick={openChainModal} type="button">
										Wrong network
									</Button>
								);
							}
							return (
								<div style={{ display: "flex", gap: 12 }}>
									<Button
										color="inherit"
										onClick={openAccountModal}
										type="button"
										size={isMobile ? "small" : "large"}
									>
										<Typography
											textTransform="capitalize"
											color="text.primary"
											fontWeight={600}
											fontSize={isMobile ? 7 : 15}
											sx={{ cursor: "pointer" }}
										>
											{isMobile
												? `${UnstoppableDomain}`
												: `${UnstoppableDomain}: ${account.displayBalance}`}
										</Typography>
									</Button>
								</div>
							);
						})()}
					</div>
				);
			}}
		</ConnectButton.Custom>
	);
};
